import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pie-echart" }

import { computed } from 'vue'
import BaseEchart from '@/base-ui/echart'
import { IDataType } from '../types'


export default _defineComponent({
  props: {
    pieData: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
  pieData: IDataType[]
}) {

const props = __props


const options = computed(() => {
  return {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'horizontal',
      left: 'left'
    },
    series: [
      {
        name: '分类数据',
        type: 'pie',
        radius: '50%',
        data: props.pieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseEchart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})